var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-slogan"},[_c('p',[_vm._v(_vm._s(_vm.$t('Index.pages1.title'))),_c('br'),_vm._v("Where Your Goals Begin")])])}
var staticRenderFns = []

export { render, staticRenderFns }